<template lang="html">
    <button
        ref="dropdown"
        v-bind="$attrs"
        class="vs-con-dropdown_x parent-dropdown"
        type="button"
        v-on="listeners"
    >
        <slot :visible="vsDropdownVisible" />
    </button>
</template>

<script>
export default {
    name: 'vx-dropdown',
    inheritAttrs: false,
    props: {
        vsTriggerClick: {
            default: false,
            type: Boolean
        },
        vsTriggerContextmenu: {
            default: false,
            type: Boolean
        },
        color: {
            default: 'primary',
            type: String
        },
        vsCustomContent: {
            default: false,
            type: Boolean
        },
        vsDropRight: {
            default: false,
            type: Boolean
        },
        preventClose: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        vsDropdownVisible_x: false,
        rightx: false
    }),
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                contextmenu: (evt) =>
                    this.vsTriggerContextmenu ? this.clickToggleMenu(evt, true) : {},
                click: (evt) => {
                    if (!this.vsTriggerContextmenu) {
                        this.clickToggleMenu(evt)
                    }
                    if (this.$el === evt.target) {
                        this.$emit('click')
                    }
                },
                mouseleave: (evt) => this.toggleMenu('out', evt),
                mouseover: (evt) => this.toggleMenu('over', evt)
            }
        },
        vsDropdownVisible: {
            get() {
                return this.vsDropdownVisible_x
            },
            set(v) {
                this.vsDropdownVisible_x = v
                this.dropdownMenuVisible = v
            }
        },
        dropdownMenu() {
            return this.$children.filter((item) => item.hasOwnProperty('dropdownVisible')).first()
        },
        dropdownMenuVisible: {
            get() {
                return this.dropdownMenu.dropdownVisible
            },
            set(v) {
                this.dropdownMenu.dropdownVisible = v
            }
        }
    },
    watch: {
        vsDropdownVisible() {
            this.changePositionMenu()
            if (this.vsDropdownVisible) {
                this.$emit('focus')
                document.addEventListener('click', this.clickx)
            } else {
                this.$emit('blur')
            }
        }
    },
    mounted() {
        this.changeColor()
        document.addEventListener('click', this.clickx)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.clickx)
    },
    methods: {
        clickx(evt) {
            this.dropdownMenu.vsCustomContent = this.vsCustomContent
            this.dropdownMenu.vsTriggerClick = this.vsTriggerClick
            this.dropdownMenu.vsDropRight = this.vsDropRight
            if ((this.vsTriggerClick || this.vsCustomContent) && this.vsDropdownVisible) {
                if (
                    evt.target !== this.$refs.dropdown &&
                    evt.target.parentNode !== this.$refs.dropdown &&
                    evt.target.parentNode.parentNode !== this.$refs.dropdown
                ) {
                    if (!this.preventClose) {
                        this.vsDropdownVisible = false
                        document.removeEventListener('click', this.clickx)
                    }
                }
            }
        },
        triggerClose() {
            this.dropdownMenu.vsCustomContent = this.vsCustomContent
            this.dropdownMenu.vsTriggerClick = this.vsTriggerClick
            this.dropdownMenu.vsDropRight = this.vsDropRight
            if ((this.vsTriggerClick || this.vsCustomContent) && this.vsDropdownVisible) {
                this.vsDropdownVisible = false
                document.removeEventListener('click', this.clickx)
            }
        },
        changeColor() {
            let child = this.$children
            child.forEach((item) => {
                if (item.$vnode.tag.indexOf('dropdown') != -1) {
                    item.color = this.color
                }
            })
        },
        changePositionMenu() {
            let scrollTopx = window.pageYOffset || document.documentElement.scrollTop
            if (this.$refs.dropdown.getBoundingClientRect().top + 300 >= window.innerHeight) {
                this.$nextTick(() => {
                    this.dropdownMenu.topx =
                        this.$refs.dropdown.getBoundingClientRect().top -
                        this.dropdownMenu.$el.clientHeight -
                        7 +
                        scrollTopx
                    this.dropdownMenu.notHeight = true
                })
            } else {
                this.dropdownMenu.notHeight = false
                this.dropdownMenu.topx =
                    this.$refs.dropdown.getBoundingClientRect().top +
                    this.$refs.dropdown.clientHeight +
                    scrollTopx -
                    5
            }
            this.$nextTick(() => {
                var w =
                    window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth
                if (
                    this.$refs.dropdown.getBoundingClientRect().left +
                        this.dropdownMenu.$el.offsetWidth >=
                    w - 25
                ) {
                    // this.rightx = true
                }
                if (
                    this.$refs.dropdown.getBoundingClientRect().right <
                    this.dropdownMenu.$el.clientWidth + 25
                ) {
                    this.dropdownMenu.leftx =
                        this.dropdownMenu.$el.clientWidth +
                        this.$refs.dropdown.getBoundingClientRect().left
                    this.rightx = true
                    return
                }

                this.dropdownMenu.leftx =
                    20 + // offset for the pointer to be centered
                    this.$refs.dropdown.getBoundingClientRect().left +
                    (this.vsDropRight
                        ? this.dropdownMenu.$el.clientWidth / 2
                        : this.$refs.dropdown.clientWidth / 2)
            })
        },
        clickToggleMenu(evt) {
            if (evt.type == 'contextmenu') {
                evt.preventDefault()
            }

            if (!this.vsTriggerClick && !this.vsTriggerContextmenu) {
                this.$emit('click')
                return
            }

            if (this.vsDropdownVisible && !evt.target.closest('.vs-dropdown--menu')) {
                this.vsDropdownVisible = false
            } else {
                this.vsDropdownVisible = true
                window.addEventListener('click', () => {
                    if (
                        !evt.target.closest('.vs-con-dropdown') &&
                        !evt.target.closest('.vs-dropdown--menu')
                    ) {
                        this.vsDropdownVisible = false
                    }
                })
            }
            this.$emit('click')
        },
        toggleMenu(typex, evt) {
            if (this.vsTriggerClick || this.vsTriggerContextmenu) {
                return
            }

            if (typex == 'over') {
                this.vsDropdownVisible = true
                return
            }

            if (evt.relatedTarget && !evt.relatedTarget.classList.contains('vs-dropdown-menu')) {
                this.vsDropdownVisible = false
            }
        }
    }
}
</script>

<style scoped>
.parent-dropdown {
    font-family: inherit;
}
.vs-con-dropdown_x {
    color: inherit;
    font-size: 1rem;
    position: relative;
    display: inline-block;
    border: 0;
    background: transparent;
}
</style>
